
























import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { AppConstants as _app } from '@/shared/app.constants';

@Component
export default class FileUpload extends Vue {
    validationMessage: string = '';

    @Prop() disabled!: any;
    @Prop({ default: 'Document'}) title!: string;
    @Prop() docList: any;

    isSelecting: boolean = false;

    onButtonClick() {
        this.isSelecting = true
        window.addEventListener('focus', () => {
            this.isSelecting = false
        }, { once: true })

        //@ts-ignore
        this.$refs.uploader.click();
    }

    onAddFiles(e) {
        let files = e.target.files[0];
        const { name, type, size } = files;

        const filteredDocs = (this.docList || []).filter(doc => Object.keys(doc).length > 0);
        if (filteredDocs.some(doc => doc.name === name)) {
            this.validationMessage = `${this.$t("A file with the same name already exists.")}`;
            return;
        }
        else{
            if(size < this.appSettings.MaxFileSizeLimit) {
            this.$emit('onFileAdded', files);
        }
        else {
            this.validationMessage = `${this.$t("Document size should be less than")} ${((this.appSettings.MaxFileSizeLimit/1024)/1024)} MB`
        }
        }
        //@ts-ignore
        this.$refs.uploader.value = null;
    }
    
}
